import '@babel/polyfill'
import Vue from 'vue'
import App from './PSM-App'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import router from './router'
import { store } from './store'
import Vuelidate from 'vuelidate'
const fb = require('./config')

Vue.config.productionTip = false
Vue.use(VueMaterial)
Vue.use(Vuelidate)
let app

fb.auth.onAuthStateChanged(function (user) {
  if (!app) {
    /* eslint-disable no-new */
    app = new Vue({
      el: '#app',
      store: store,
      router,
      render: h => h(App)
    })
  }
})
